import React        from 'react'

const Container = props => {
    return (
        <div className="about-container">
            { props.children }
        </div>
    )
}

export default Container
